/**
 * **Syfan** service: SharePoint/Excel grid rows for TMS customer **Agile** (Agile Cold-style
 * tender workbook). The invoice column drives which loads still need to be built.
 */
export interface SharepointAgileRow {
  sheetKind: 'agile';
  /** 1-based row index in the captured grid (stable id; col A is Genset Y/N, not a row key). */
  index: string;
  loadDay: string; // LOAD DAY
  customerPo: string; // Customer PO #
  bookingNumber: string; // Booking Number
  invoiceNumber: string; // Invoice #
  containerNumber: string; // Container #
  datePulledAtPort: string; // Date Pulled @ Port
  /** Same calendar meaning as `loadDay` on Syfan sheets (often col H; col B is also load day). */
  inRouteToAgile: string; // In Route to Agile
  arrivedAtAgile: string; // Arrived at Agile
  departedAgile: string; // Departed Agile
  sealNumberLoaded: string; // Seal # (Loaded)
  inGateReturned: string; // In Gate (returned)
  earlyReturnDate: string; // Early return date
  cutDate: string; // Cut Date
  vessel: string; // VESSEL
  comment: string; // Comment
  approvedBobtail: string; // Approved Bobtail
  daysOutOfPort: string; // Days out of Port
  anticipatedDaysOutOfPort: string; // Anticipated Days Out of Port
}

/** Parsed row from the extension-owned Agile EWA transport. */
export type SharepointRow = SharepointAgileRow;

export function isSharepointAgileRow(
  row: SharepointRow
): row is SharepointAgileRow {
  return row.sheetKind === 'agile';
}
